import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../store/Store'
import {taskApi} from './Task.api'
import { IFilterDto, TSort } from '../../../common/model/Core.model'
import { IATask, ITaskDto } from './Task.model'

type InitialState = {
  tasks: {
    error?: string
    loading: boolean
    data: ITaskDto[]
    pagination?: {
      limit?: number
      sort?: TSort
      page?: string | undefined
    }
    filters?: IFilterDto[]
  }
  task: {
    error?: string
    loading: boolean
    data?: IATask
  }
}
const initialState = {
  tasks: {
    error: undefined,
    loading: false,
    data: [],
    pagination: {
      limit: 25,
      sort: 'ASC',
      page: undefined,
    },
    filters: undefined,
  },
  task: {
    error: undefined,
    loading: false,
    data: undefined,
  },
} as InitialState

export const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      //GetById
      .addMatcher(taskApi.endpoints.taskGetById.matchPending, (state) => {
        state.task = {
          ...initialState.task,
          error: undefined,
          loading: true,
          data: undefined,
          // counter: undefined,
          // media: [],
        }
      })
      .addMatcher(taskApi.endpoints.taskGetById.matchFulfilled, (state, action) => {
        state.task = {
          error: undefined,
          loading: false,
          data: action.payload,
          // counter: action.payload.counter,
          // media: action.payload.media,
        }
      })
      .addMatcher(taskApi.endpoints.taskGetById.matchRejected, (state, action) => {
        state.task = {
          ...initialState.task,
          error: action.error.message,
          loading: false,
        }
      })
      //Create
      .addMatcher(taskApi.endpoints.taskCreate.matchPending, (state) => {
        return {
          ...state,
          task: {
            ...initialState.task,
            error: undefined,
            loading: true,
          },
        }
      })
      .addMatcher(taskApi.endpoints.taskCreate.matchFulfilled, (state, action) => {
        return {
          ...state,
          task: {
            ...state.task,
            error: undefined,
            loading: false,
            data: action.payload,
          },
        }
      })
      .addMatcher(taskApi.endpoints.taskCreate.matchRejected, (state, action) => {
        return {
          ...state,
          task: {
            ...state.task,
            error: action.error.message,
            loading: false,
          },
        }
      })
      //DeleteById
      .addMatcher(taskApi.endpoints.taskDeleteById.matchPending, (state) => {
        return {
          ...state,
          task: {
            ...initialState.task,
            error: undefined,
            loading: true,
          },
        }
      })
      .addMatcher(taskApi.endpoints.taskDeleteById.matchFulfilled, (state, action) => {
        return {
          ...state,
          task: {
            ...state.task,
            error: undefined,
            loading: false,
          },
        }
      })
      .addMatcher(taskApi.endpoints.taskDeleteById.matchRejected, (state, action) => {
        return {
          ...state,
          task: {
            ...state.task,
            error: action.error.message,
            loading: false,
          },
        }
      })
      //UpdateById
      .addMatcher(taskApi.endpoints.taskUpdateById.matchPending, (state) => {
        return {
          ...state,
          task: {
            ...state.task,
            error: undefined,
            loading: true,
          },
        }
      })
      .addMatcher(taskApi.endpoints.taskUpdateById.matchFulfilled, (state, action) => {
        return {
          ...state,
          task: {
            ...state.task,
            error: undefined,
            loading: false,
            data: action.payload,
          },
        }
      })
      .addMatcher(taskApi.endpoints.taskUpdateById.matchRejected, (state, action) => {
        return {
          ...state,
          task: {
            ...state.task,
            error: action.error.message,
            loading: false,
          },
        }
      })
  },
})

export const {} = taskSlice.actions
export default taskSlice.reducer
export const selectTasksError = (state: RootState) => state.taskReducer.tasks.error
export const selectTasksLoading = (state: RootState) => state.taskReducer.tasks.loading
export const selectTasks = (state: RootState) => state.taskReducer.tasks.data
export const selectTasksPagination = (state: RootState) => state.taskReducer.tasks.pagination
export const selectTasksFilters = (state: RootState) => state.taskReducer.tasks.filters
export const selectTaskError = (state: RootState) => state.taskReducer.task.error
export const selectTaskLoading = (state: RootState) => state.taskReducer.task.loading
export const selectTask = (state: RootState) => state.taskReducer.task.data